import {
    Box,
    Divider,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    Stack,
    Text,
    useDisclosure
} from '@chakra-ui/react'
import {
    forwardRef,
    ForwardRefRenderFunction,
    useImperativeHandle
} from 'react'
import formatter from 'utils/formatter'
import { Notification, PreviewRef } from '../intefaces'

interface NotificationPreviewProps {
    notification: Notification
}

const NotificationPreviewFC: ForwardRefRenderFunction<
    PreviewRef,
    NotificationPreviewProps
> = ({ notification }, ref) => {
    const { isOpen, onOpen, onClose } = useDisclosure()

    useImperativeHandle(ref, () => ({
        openPreview() {
            onOpen()
        }
    }))

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            size={{ base: 'full', md: '2xl' }}
            scrollBehavior="inside"
        >
            <ModalOverlay />
            <ModalContent minHeight="380px" p={4}>
                <ModalCloseButton />
                <ModalHeader>
                    <Box mb={2}>
                        <Text fontSize="xl" fontWeight="bold" noOfLines={3}>
                            {notification?.titulo}
                        </Text>
                        <Text
                            fontSize="sm"
                            color="gray.500"
                            fontWeight="normal"
                        >
                            {formatter.dataWithHour(
                                notification?.dataCriacao || ''
                            )}
                        </Text>
                    </Box>
                    <Divider />
                </ModalHeader>

                <ModalBody maxHeight="350px" overflowY="auto">
                    <Stack spacing={4}>
                        <Text fontSize="md" whiteSpace="pre-wrap">
                            {notification?.descricao}
                        </Text>
                    </Stack>
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

export const NotificationPreview = forwardRef(NotificationPreviewFC)
